export enum PageSectionType {
  PAGE_MESSAGING_MODULE = '#pageMessagingModule',
  STAY_DETAILS_MESSAGING_MODULE = '#changeStayDetailsTop',
  STAY_MGMT_TITLE_MODULE = '#stayMgmtTitle'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/page/page-section.model.ts